<template>
  <div>
    <div class="announcement" v-if="componentState">
      <div class="announcement_title">
        <!-- 请选择发布的对象 -->
        <span @click="noticeAdmin()">管理历史发布公告 <tt>></tt></span>
      </div>

      <!-- <div class="announcement_btn">
        <div
          class="plain_btn"
          v-for="(item,index) in plainBtn"
          :key="item.value"
          @click="choiceAddress(item,index)"
        >
          <div
            :class="addressState == index?'addrressBtn':'Bat'"
            type="primary"
            plain
          >{{item.name}}</div>
        </div>
      </div> -->
      <div class="announcement_title">请输入新发布的公告标题</div>

      <div class="notice_title">
        <input
          type="text"
          placeholder="这里输入公告的标题"
          v-model="params.title"
          maxlength="50"
        />
      </div>

      <div class="announcement_title notiecetitle">请输入新发布的内容</div>

      <div class="release">
        <textarea
          type="text"
          placeholder="请输入发布的内容"
          v-model="params.context"
          maxlength="500"
        ></textarea>
      </div>
      <div class="publishNow">
        <el-button type="primary" @click="initQueryList()" style="margin-top:50px" class="publishNowBtn"
          >立即发布</el-button
        >
      </div>
    </div>

    <noticeList
      v-if="!componentState"
      @backNotices="backNotices"
      @listHistory="listHistory"
      :listHistoryData="listHistoryData"
      @pagePageSize="pagePageSize"
    ></noticeList>
  </div>
</template>
<script>
import noticeList from "../../components/noticeList.vue";
export default {
  components: {
    noticeList: noticeList,
  },
  data() {
    return {
      componentState: true,
      parme: {
        params: {
          page: "1",
          type: 2,
          page_size: "8",
        },
      },
      params: {
        context: "",
        type: 2,
        title: "",
      },
      total: "",
      addressState: "0",
      listHistoryData: [],
      plainBtn: [
        { name: "全部", value: 2 },
        { name: "扫码后台", value: 0 },
        { name: "包月后台", value: 1 },
      ],
    };
  },
  created() {
    // this.listHistory();
  },
  methods: {
    // 创建公告
    initQueryList() {
      console.log(this.params);
      this.$http.post(this.$api.api.notice, this.params).then((res) => {
        if (res.data.code != 1) {
          return this.$message.error(res.data.result);
        }
        this.params.context = "";
        this.params.title = "";
        this.params.type = "";
        return this.$message.success(res.data.result);
      });
    },
    // 选择后台
    choiceAddress(val, index) {
      this.addressState = index;
      this.params.type = val.value;
      console.log(val.value, index);
    },
    noticeAdmin() {
      this.listHistory();
      this.componentState = false;
    },
    // 历史记录列表
    listHistory() {
      this.$http.get(this.$api.api.notice, this.parme).then((res) => {
        if (res.data.code != 1) {
          return this.$message.error(res.data.result);
        }
        this.listHistoryData = res.data;
      });
    },
    pagePageSize(val) {
      console.log(val);
      this.parme.params.page = val;
      this.listHistory();
    },
    backNotices(data) {
      this.componentState = data;
    },
  },
};
</script>
<style scoped lang="scss">
.announcement {
  position: relative;
  padding: 20px;
  .announcement_title {
    color: #333;
    font-weight: bold;
    width: 100%;
    font-size: 18px;
    // position: relative;
    span {
      font-weight: normal;
      position: absolute;
      top: 0;
      right: 0;
      color: #6692ff;
      cursor: pointer;
      font-size: 14px;
      margin: 20px;
      tt {
        font-family: "SimSun" !important;
        font-weight: 600;
      }
    }
    span:hover {
      color: #759dff;
    }
    span:active {
      color: #537fed;
    }
  }
  .notiecetitle {
    margin: 40px 0 0;
  }
  .announcement_btn {
    padding-top: 20px;
    padding-bottom: 20px;
    display: flex;
    .plain_btn {
      margin-right: 20px;
    }
  }
  .notice_title {
    padding-top: 20px;
    padding-bottom: 20px;
    height: 60px;
    input {
      text-indent: 20px;
      height: 60px;
      background: #fff;
      border: none;
      width: 100%;
      outline: none;
      font-size: 16px;
      color: #999;
    }
  }
  .release {
    height: 250px;
    width: 100%;

    textarea {
      margin-top: 20px;
      padding-top: 20px;
      padding-left: 20px;
      width: 100%;
      border: none;
      outline: none;
      height: 100%;
      font-size: 16px;
      color: #999;
      background: #fff;
    }
    .publishNow {
      position: absolute;
      // bottom: 120px;
      // margin-top: 150px;
      left: 20px;

      .publishNowBtn {
        width: 100px !important;
      }
    }
  }
}
.addrressBtn {
  color: #fff;
  background: #409eff;
  width: 80px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  border-radius: 3px;
  font-weight: bold;
  font-size: 14px;
  cursor: pointer;
}
.addrressBtn:hover {
  background: #66b1ff;
  cursor: pointer;
}

.Bat {
  border: 1px solid #409eff;
  width: 80px;
  height: 40px;
  color: #409eff;
  line-height: 40px;
  text-align: center;
  border-radius: 3px;
  font-weight: bold;
  font-size: 14px;
  cursor: pointer;
}
.Bat:hover {
  background: #ecf5ff;
}
</style>